export const tableHeaderAsmCert = (t) => [
  {
    id: 'asset',
    type: 'text',
    value: t('asm:tabCert.table.asset'),
  },
  {
    id: 'dns_names',
    type: 'text',
    value: t('asm:tabCert.table.dnsNames'),
    maxSize: 32
  },
  {
    id: 'issuer',
    type: 'text',
    value: t('asm:tabCert.table.issuer'),
    minWidth: '180px'
  },
  {
    id: 'pubkey_sha256',
    type: 'text',
    value: t('asm:tabCert.table.publicKey'),
    maxSize: 26
  },
  {
    id: 'valid_till',
    type: 'datetime',
    value: t('asm:tabCert.table.validUntil'),
  },
];
